import script from "./HomePageRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageRenderer.vue?vue&type=script&setup=true&lang=js"

import "./HomePageRenderer.vue?vue&type=style&index=0&id=a4782fbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4782fbe"]])

export default __exports__